import { computed, ElementRef, input, model, viewChild, DOCUMENT } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { copyToClipboard } from '../copy-to-clipboard/helper';
import { UiIconComponent } from '../icons';
import * as i0 from "@angular/core";
const _c0 = ["content"];
const _c1 = ["*"];
export let UiCopyContentComponent = /*#__PURE__*/(() => {
  class UiCopyContentComponent {
    constructor(document, host) {
      this.document = document;
      this.host = host;
      this.value = input(...(ngDevMode ? [undefined, {
        debugName: "value"
      }] : /* istanbul ignore next */[]));
      this.label = input('kopieren', ...(ngDevMode ? [{
        debugName: "label"
      }] : /* istanbul ignore next */[]));
      this.showInput = input(true, ...(ngDevMode ? [{
        debugName: "showInput"
      }] : /* istanbul ignore next */[]));
      this.error = model(...(ngDevMode ? [undefined, {
        debugName: "error"
      }] : /* istanbul ignore next */[]));
      this.status = model("unknown", ...(ngDevMode ? [{
        debugName: "status"
      }] : /* istanbul ignore next */[]));
      this._label = computed(() => {
        const status = this.status();
        if (status === 'done') return 'kopiert!';
        if (status === 'error') return 'Fehler';
        return this.label();
      }, ...(ngDevMode ? [{
        debugName: "_label"
      }] : /* istanbul ignore next */[]));
      this._icon = computed(() => {
        const status = this.status();
        if (status === 'done') return 'check';
        if (status === 'error') return 'times';
        return 'copy';
      }, ...(ngDevMode ? [{
        debugName: "_icon"
      }] : /* istanbul ignore next */[]));
      this.contentEl = viewChild('content', ...(ngDevMode ? [{
        debugName: "contentEl"
      }] : /* istanbul ignore next */[]));
    }
    getValue() {
      const customValue = this.value();
      // if value is set to true, this is being interpreted as "enabling" default behavior
      if (customValue && customValue !== true) {
        if (typeof customValue === 'function') return customValue();
        return '' + customValue;
      } else {
        // in case no value is set, fall back to use innerText of content element
        return this.contentEl().nativeElement.innerText;
      }
    }
    copyToClipboard(event) {
      event.stopPropagation();
      copyToClipboard(this.getValue()).then(() => {
        this.status.set('done');
        setTimeout(() => {
          this.status.set('unknown');
        }, 3000);
      }, error => {
        this.status.set('error');
        this.error.set(error);
        alert('Kopieren fehlgeschlagen, bitte manuell markieren und kopieren!');
      });
    }
    static {
      this.ɵfac = function UiCopyContentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiCopyContentComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiCopyContentComponent,
        selectors: [["ui-copy-content"]],
        viewQuery: function UiCopyContentComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.contentEl, _c0, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          value: [1, "value"],
          label: [1, "label"],
          showInput: [1, "showInput"],
          error: [1, "error"],
          status: [1, "status"]
        },
        outputs: {
          error: "errorChange",
          status: "statusChange"
        },
        ngContentSelectors: _c1,
        decls: 4,
        vars: 2,
        consts: [["content", ""], [3, "click", "title", "icon"]],
        template: function UiCopyContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "span", null, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "ui-icon", 1);
            i0.ɵɵlistener("click", function UiCopyContentComponent_Template_ui_icon_click_3_listener($event) {
              return ctx.copyToClipboard($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("title", ctx._label())("icon", ctx._icon());
          }
        },
        dependencies: [FormsModule, UiIconComponent],
        styles: ["span[_ngcontent-%COMP%]{display:contents}ui-icon[_ngcontent-%COMP%]{opacity:0;margin-left:3px}ui-icon[_ngcontent-%COMP%]:hover{color:var(--primaryColor)!important;cursor:pointer}[_nghost-%COMP%]{margin:-3px -5px;padding:3px 5px}[_nghost-%COMP%]:hover{display:inline-block;background:var(--inputBgColor);border-radius:4px}[_nghost-%COMP%]:hover   ui-icon[_ngcontent-%COMP%]{opacity:1}\n\n/*# sourceMappingURL=copy-content.ts-angular-inline--31.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return UiCopyContentComponent;
})();